import {
  Chart as ChartJS,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
} from "chart.js";

import { Bar } from "react-chartjs-2";
import { useRef } from "react";
import ChartToolbar from "./ChartToolbar";


// Register the Chart.js components required for this bar chart.
ChartJS.register(
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);


// Defines the order that days should appear on the x-axis.
const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];


function AverageChargesDayOfWeekChart({ title, data = [] }) {
  const chartRef = useRef(null);

  // Stores charging data grouped by location.
  const groupedByLocation = {};


  // Colours used to distinguish different charging locations.
  const chartColours = [
    "#2e7d32",
    "#f9a825",
    "#1565c0",
    "#8e24aa",
    "#ef6c00",
    "#00897b",
    "#c62828",
    "#6d4c41",
    "#5e35b1",
    "#0277bd",
    "#558b2f",
    "#ad1457"
  ];


  // Convert API data into values grouped by location and day.
  data.forEach((row) => {
    const location =
      row.locationName ||
      row.chargingStationId ||
      "Unknown Location";

    if (!groupedByLocation[location]) {
      groupedByLocation[location] = {};
    }

    groupedByLocation[location][row.dayName] = Number(row.value);
  });


  // Create one chart dataset for each charging location.
  const datasets = Object.keys(groupedByLocation).map((location, index) => {
    const colour = chartColours[index % chartColours.length];

    return {
      label: location,
      data: days.map((day) => groupedByLocation[location][day] || 0),
      backgroundColor: colour,
      borderColor: colour,
      borderWidth: 1,

      // Allow the bars to occupy more of the available space while
      // preventing them from becoming excessively wide.
      barPercentage: 0.95,
      categoryPercentage: 0.9,
      maxBarThickness: 55
    };
  });


  const chartData = {
    labels: days,
    datasets
  };


  // Configure the stacked bar chart appearance and behaviour.
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    interaction: {
      mode: "index",
      intersect: false
    },
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          text: "Day"
        }
      },
      y: {
        stacked: true,
        beginAtZero: true,
        title: {
          display: true,
          text: "Average Charges"
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: "right",
        labels: {
          boxWidth: 14,
          boxHeight: 14,
          padding: 14
        }
      },
      tooltip: {
        mode: "index",
        intersect: false
      }
    }
  };


  return (
    <article className="chart-card">
      <div className="chart-card-header">
        <div className="chart-card-title">
          <h2>{title}</h2>

          <p>
            Average number of charging sessions by day of the week.
          </p>
        </div>

        {/* Provides chart actions such as downloading/exporting */}
        <ChartToolbar
          chartRef={chartRef}
          title={title}
        />
      </div>

      {/* Render the completed stacked bar chart */}
      <div className="chart-canvas-container">
        <Bar
          ref={chartRef}
          data={chartData}
          options={options}
        />
      </div>
    </article>
  );
}


export default AverageChargesDayOfWeekChart;